import { onMounted, onUnmounted, ref } from 'vue'

export function useIsDesktop(minWidth = 768) {
    const isDesktop = ref(false)
    let mediaQuery: MediaQueryList | undefined

    function updateIsDesktop(event?: MediaQueryListEvent) {
        isDesktop.value = event?.matches ?? mediaQuery?.matches ?? false
    }

    onMounted(() => {
        if (typeof window === 'undefined') {
            return
        }

        mediaQuery = window.matchMedia(`(min-width: ${minWidth}px)`)
        updateIsDesktop()
        mediaQuery.addEventListener('change', updateIsDesktop)
    })

    onUnmounted(() => {
        mediaQuery?.removeEventListener('change', updateIsDesktop)
    })

    return isDesktop
}
